import ApiClient from '../helper/apiClient';

class LoggerService {
  static backendLogEndpoint = null;

  static configure({ backendLogEndpoint }) {
    this.backendLogEndpoint = backendLogEndpoint;
  }

  static log(...args) {
    // Local log
    console.info('[LoggerService]', ...args);
    // Remote log
    this.sendLogToBackend(args);
  }

  static sendLogToBackend(logArgs) {
    if (!this.backendLogEndpoint) return;
    try {
      ApiClient.getZoomAppBffInstance().post(this.backendLogEndpoint, {
        timestamp: new Date().toISOString(),
        log: logArgs.map(a => (typeof a === 'object' ? JSON.stringify(a) : String(a))).join(' ')
      });
    } catch {}
  }
}

export default LoggerService;
